var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgCaseNotice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_case_notice_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EEF0F3",
  d: "M62 32c0 16.569-13.431 30-30 30C15.432 62 2 48.569 2 32 2 15.432 15.432 2 32 2c16.569 0 30 13.432 30 30"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BEC5CC",
  d: "M35.567 18.324a3.583 3.583 0 1 0-7.133 0l.585 6.124 1.168 12.091a1.28 1.28 0 0 0 1.274 1.157h1.079c.659 0 1.21-.5 1.274-1.157l1.168-12.091zm-3.566 24.501c-1.76 0-3.187 1.445-3.187 3.205s1.427 3.206 3.187 3.206 3.186-1.446 3.186-3.206-1.427-3.205-3.186-3.205"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_case_notice_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
})))));
export default SvgImgCaseNotice;